/**
 * ago-2026 · Bloque A — ETIQUETAS DINÁMICAS POR ACTIVIDAD VULNERABLE.
 *
 * Las 17 actividades del Art. 17 LFPIORPI comparten las mismas pantallas, pero cada una
 * tiene SU nombre de bien y SU fracción. El catálogo del backend ya los publica
 * (`av_actividad_config.bien_label` / `bien_label_plural` y las fracciones del giro); este
 * hook es el único punto donde el frontend los lee, para que ninguna pantalla vuelva a
 * escribir "inmueble" ni "Fr. V" a mano.
 *
 * Fuente: GET /api/av/mi-actividad → { giro, metadata, config, fracciones[], tipos_acto[] }
 * SOFOM no entra aquí: ese endpoint responde 403 y el hook devuelve los genéricos.
 */
import { useEffect, useState } from "react";

import { api } from "@/lib/api";

const GENERICO = {
  giro: null,
  cargando: true,
  bien: "Bien",
  bienes: "Bienes",
  bienLabelDefinido: true,
  tipoBien: null,
  fracciones: [],
  fraccionesRaw: [],
  tiposActo: [],
  frTexto: "Art. 17 LFPIORPI",
  articulo: "Art. 17 LFPIORPI",
  nombreCorto: "",
  nombreLargo: "",
  config: {},
};

let _cache = null;      // promesa compartida: una sola llamada por sesión de pestaña

function listaEs(items) {
  if (items.length === 0) return "";
  if (items.length === 1) return items[0];
  return `${items.slice(0, -1).join(", ")} y ${items[items.length - 1]}`;
}

function normalizar(d) {
  const cfg = d?.config || {};
  const meta = d?.metadata || {};
  const fracciones = (d?.fracciones || []).map((f) => f.fraccion).filter(Boolean);
  // El catálogo guarda "V_bis"; el formato oficial lo escribe "V Bis".
  const bonitas = fracciones.map((f) => String(f).replace(/_bis$/i, " Bis"));
  const frTexto = bonitas.length ? `Fr. ${listaEs(bonitas)}` : "Art. 17 LFPIORPI";
  return {
    giro: d?.giro || null,
    cargando: false,
    // Si una actividad no declara su bien en el catálogo, se usa el genérico "Bien":
    // nunca se cae a "inmueble".
    bien: cfg.bien_label || "Bien",
    bienes: cfg.bien_label_plural || (cfg.bien_label ? `${cfg.bien_label}s` : "Bienes"),
    bienLabelDefinido: Boolean(cfg.bien_label),
    tipoBien: cfg.tipo_bien || null,
    fracciones: bonitas,
    fraccionesRaw: fracciones,
    tiposActo: d?.tipos_acto || [],
    frTexto,
    articulo: bonitas.length ? `Art. 17 ${frTexto}` : "Art. 17 LFPIORPI",
    nombreCorto: meta.nombre_corto || "",
    nombreLargo: meta.nombre_largo || "",
    config: cfg,
  };
}

export function useMiActividad() {
  const [estado, setEstado] = useState(GENERICO);
  useEffect(() => {
    let vivo = true;
    if (!_cache) _cache = api.get("/av/mi-actividad").then((r) => r.data);
    _cache
      .then((d) => { if (vivo) setEstado(normalizar(d)); })
      .catch(() => { if (vivo) setEstado({ ...GENERICO, cargando: false }); });
    return () => { vivo = false; };
  }, []);
  return estado;
}

/** Solo para pruebas / cambio de sesión: obliga a releer el catálogo. */
export function limpiarCacheMiActividad() {
  _cache = null;
}
